module.exports = new __parcel__URL__("35270_sq.d278a421.jpg").toString();